<div class="billing-periods-modal-body">
  <form [formGroup]="filterDateForm" class="w-50p flex-row-container items-baseline gap-32 py-16">
    <app-month-year-field
      class="flex-2"
      [label]="'CONTRACT.PAYMENTS.MODAL.DATES' | translate"
      [minDate]="minDate"
      [maxDate]="maxDate"
      formControlName="date"
      (newDateEvent)="setNewDate($event)"></app-month-year-field>
  </form>

  <ng-container *ngIf="billPeriodsData$ | async as billingPeriod ; else loading">
    <mat-card class="my-16 bg-ligth-opaque mat-elevation-z0">
      <mat-card-header class="items-center border-header">
        <div mat-card-avatar class="example-header-image">
          <img class="w-32 h-32" [src]="'/assets/svg/calendar.svg'" alt="icon card" />
        </div>
        <mat-card-title class="m-0 fs-24 text-light-gray">{{textDateHeader | titlecase }}</mat-card-title>
      </mat-card-header>
      <mat-card-content class="px-16">
        <div *ngFor="let period of billingPeriod">
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.DEBT_ENABLED' | translate}}</div>
            <div class="flex-1 end fs-14 fw-700 text-purple capitalize">{{period.debt_enabled }}</div>
          </div>
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.CODE' | translate}}</div>
            <div class="flex-2 end fs-14 text-black fw-700">{{period?.code}}</div>
          </div>
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.PAYMENT_DATE' | translate}}</div>
            <div class="flex-1 end fs-14 text-black fw-700">{{period?.payment_date}}</div>
          </div>
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.INIT_DATE' | translate}}</div>
            <div class="flex-1 end fs-14 text-black fw-700">{{period?.init_date}}</div>
          </div>
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.CUT_OFF_DATE' | translate}}</div>
            <div class="flex-1 end fs-14 text-black fw-700">{{period?.cut_off_date}}</div>
          </div>
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.EXTRACT_DATE' | translate}}</div>
            <div class="flex-1 end fs-14 text-black fw-700">{{period?.extract_date}}</div>
          </div>
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.SETTLEMENT_GROUP' | translate}}</div>
            <div class="flex-1 end fs-14 text-black fw-700">{{period?.settlement_group}}</div>
          </div>
          <div class="flex-row-container py-19 item-row">
            <div class="flex-1 start fs-14 text-light-gray fw-400">{{'CONTRACT.PAYMENTS.MODAL.COUNTRY' | translate}}</div>
            <div class="flex-1 end fs-14 text-black fw-700">{{period?.country}}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-template #loading>
    <div class="p-32 my-48" *ngIf="!this.errorThrown">
      <div class="flex-col-container justify-center items-center spiner">
        <mat-spinner [diameter]="70" style="margin: 30px 0 15px 0"></mat-spinner>
        <span class="fs-20 mt-8">{{'CONTRACT.PAYMENTS.MODAL.LOADER.TITLE' | translate}}</span>
        <p class="text-light-gray fs-14">{{'CONTRACT.PAYMENTS.MODAL.LOADER.SUBTITLE' | translate}}</p>
      </div>
    </div>

    <div *ngIf="this.errorThrown" class="flex-col-container justify-center items-center spiner">
      <img class="w90 h90" [src]="'/assets/svg/slight_flaw.svg'" alt="fail_service_bill_periods" />
      <span class="fs-20 mt-8 text-gray">{{'CONTRACT.PAYMENTS.MODAL.ERROR.TITLE' | translate}}</span>
      <p class="text-gray fs-14">
        {{'CONTRACT.PAYMENTS.MODAL.ERROR.SUBTITLE_ONE' | translate}}
        <a (click)="reload()" class="text-purple cursor-pointer">{{'CONTRACT.PAYMENTS.MODAL.ERROR.SUBTITLE_TWO' | translate}}</a>
        {{'CONTRACT.PAYMENTS.MODAL.ERROR.SUBTITLE_THREE' | translate}}
      </p>
    </div>
  </ng-template>
</div>
